import { createSlice, createSelector } from "@reduxjs/toolkit";
import * as rulesResolver from "domain/rulesResolver";
import * as persistenceActionTypes from "store/actions/persistence/persistenceActionTypes";

const initialState = {};

const rulesSlice = createSlice({
  name: "rules",
  initialState,
  reducers: {
    set: (state, action) => {
      return {
        ...initialState,
        ...action.payload,
      };
    },
    update: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateByKey: (state, action) => {
      const key = action.payload?.key;
      const update = action.payload?.update;
      if (key == null || update == null) {
        return;
      }
      return {
        ...state,
        byKey: {
          ...state?.byKey,
          [key]: {
            ...update(state?.byKey?.[key]),
            ...action.values,
          },
        },
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      persistenceActionTypes.LOAD_SUBMISSION_SUCCEEDED,
      (_, action) => action?.payload?.data?.state?.rules ?? initialState
    );
  },
});

export const selectInput = (state) => state?.rules ?? null;

export const select = createSelector([selectInput], (input) =>
  rulesResolver.resolveRules(input)
);

export const selectByKey = (key) => (state) => select(state)?.byKey?.[key];

export const { set, update, updateByKey } = rulesSlice.actions;

export default rulesSlice;
